export default __webpack_public_path__ + "static/media/female.00354e0b.svg";